import styled from "styled-components";

import { ActionButtonHtmlStyle, ActionButtonStyle } from "../styles/ButtonStyle";

// Export the styled component/s
export const PrimaryButton = styled(ActionButtonStyle).attrs(() => ({ className: "aevi-button aevi-button-primary" }))``;

export const SecondaryButton = styled(ActionButtonStyle).attrs(() => ({ className: "aevi-button aevi-button-secondary" }))``;
export const DangerButton = styled(ActionButtonStyle).attrs(() => ({ className: "aevi-button aevi-button-danger" }))``;

export const PrimaryButtonHtml = styled(ActionButtonHtmlStyle).attrs(() => ({ className: "aevi-button aevi-button-primary" }))``;

export const SecondaryButtonHtml = styled(ActionButtonHtmlStyle).attrs(() => ({ className: "aevi-button aevi-button-secondary" }))``;
